import React from "react"
import * as style from "./style.module.css"
import BackgroundMedia from "/src/components/BackgroundMedia"

const Component = ({ mainTitle, dynamicTitle, media }) => {
  return (
    <div className={style.top_visual}>
      <div className={style.top_visual_media}>
        <BackgroundMedia media={media} />
      </div>
      <div className={style.top_visual_title}>
        <h1>{mainTitle}</h1>
        <small>{dynamicTitle}</small>
        <div className={style.top_visual_decoration}></div>
      </div>
    </div>
  )
}

export default Component
